import RouteWrapperComponent from "./RouteWrapperComponent";

export default (route) => {
	return {
		...route,
		component: async () => await RouteWrapperComponent(route.component)
	};
};
